// ─── LANGUAGE DETECTION ────────────────────────────────────────────────────
export function detectLanguage() {
  const lang = (navigator.language || 'pt').split('-')[0].toLowerCase();
  return TRANSLATIONS[lang] ? lang : 'en';
}

export function getAILanguage(lang) {
  return {
    pt: 'Responda sempre em português do Brasil com acentuação correta.',
    en: 'Always respond in English.',
    es: 'Responde siempre en español.',
    fr: 'Répondez toujours en français.',
    de: 'Antworte immer auf Deutsch.',
    it: 'Rispondi sempre in italiano.',
    ja: '常に日本語で答えてください。',
    zh: '始终用中文回答。',
  }[lang] || 'Always respond in English.';
}

// ─── GENRES / TONES / POV ─────────────────────────────────────────────────
export const GENRES_I18N = {
  pt: ["Fantasia","Ficção Científica","Romance","Thriller/Suspense","Terror","Aventura","Drama","Mistério","Histórico","Distopia","Conto","Biografia Fictícia"],
  en: ["Fantasy","Science Fiction","Romance","Thriller/Suspense","Horror","Adventure","Drama","Mystery","Historical","Dystopia","Short Story","Fictional Biography"],
  es: ["Fantasía","Ciencia Ficción","Romance","Thriller/Suspenso","Terror","Aventura","Drama","Misterio","Histórico","Distopía","Cuento","Biografía Ficticia"],
  fr: ["Fantaisie","Science-Fiction","Romance","Thriller/Suspense","Horreur","Aventure","Drame","Mystère","Historique","Dystopie","Nouvelle","Biographie Fictive"],
  de: ["Fantasy","Science-Fiction","Romantik","Thriller/Spannung","Horror","Abenteuer","Drama","Krimi","Historisch","Dystopie","Kurzgeschichte","Fiktive Biografie"],
  it: ["Fantasy","Fantascienza","Romance","Thriller/Suspense","Horror","Avventura","Dramma","Giallo","Storico","Distopia","Racconto","Biografia Fittizia"],
};

export const TONES_I18N = {
  pt: ["Épico e grandioso","Sombrio e tenso","Leve e divertido","Emotivo e profundo","Ação acelerada","Intimista e contemplativo","Lírico e poético","Humorístico"],
  en: ["Epic and grand","Dark and tense","Light and fun","Emotional and deep","Fast-paced","Intimate and contemplative","Lyrical and poetic","Humorous"],
  es: ["Épico y grandioso","Oscuro y tenso","Ligero y divertido","Emotivo y profundo","Acción acelerada","Íntimo y contemplativo","Lírico y poético","Humorístico"],
  fr: ["Épique et grandiose","Sombre et tendu","Léger et amusant","Émouvant et profond","Action rapide","Intime et contemplatif","Lyrique et poétique","Humoristique"],
  de: ["Episch und grandios","Dunkel und angespannt","Leicht und unterhaltsam","Emotional und tiefgründig","Actionreich","Intim und kontemplativ","Lyrisch und poetisch","Humoristisch"],
  it: ["Epico e grandioso","Oscuro e teso","Leggero e divertente","Emotivo e profondo","Azione frenetica","Intimo e contemplativo","Lirico e poetico","Umoristico"],
};

export const POV_I18N = {
  pt: ["Primeira pessoa (Eu)","Terceira pessoa limitada","Terceira pessoa onisciente"],
  en: ["First person (I)","Third person limited","Third person omniscient"],
  es: ["Primera persona (Yo)","Tercera persona limitada","Tercera persona omnisciente"],
  fr: ["Première personne (Je)","Troisième personne limitée","Troisième personne omnisciente"],
  de: ["Erste Person (Ich)","Dritte Person begrenzt","Dritte Person allwissend"],
  it: ["Prima persona (Io)","Terza persona limitata","Terza persona onnisciente"],
};

// ─── TRANSLATIONS ──────────────────────────────────────────────────────────
const TRANSLATIONS = {
  pt: {
    tagline: 'Do pensamento ao livro — sem alucinações',
    ph0: '1. Bíblia', ph1: '2. Roteiro', ph2: '3. Escrita',
    biblia_sub: 'Conte sua ideia — vamos construir a bíblia do livro juntos',
    biblia_label: 'Sua Ideia',
    biblia_ph: 'Escreva à vontade — uma frase, um parágrafo, um worldbuilding completo.\n\nEx: Quero escrever uma fantasia sobre um jovem ferreiro que descobre que pode forjar armas usando memórias. O antagonista é um rei imortal que coleciona memórias roubadas...',
    biblia_hint: 'Ctrl+Enter para enviar',
    biblia_btn: 'Vamos criar meu livro →',
    load_building: 'Construindo a bíblia do livro...',
    load_chars: 'Criando personagens...',
    load_outline: 'Gerando roteiro...',
    load_writing: 'Escrevendo capítulo...',
    load_summary: 'Gerando resumo canônico...',
    chars_title: 'Personagens',
    chars_regen: '↻ Regenerar todos',
    chars_adjust: '✏️ Ajustar este personagem',
    chars_what: 'O que você quer mudar?',
    chars_confirm: '✓ Ajustar',
    chars_cancel: 'Cancelar',
    chars_next: 'Refinar o mundo →',
    chars_hint: 'Satisfeito com os personagens? Avance para refinar o mundo.',
    refine_title: 'Refinando a Bíblia do Mundo',
    refine_intro: 'Ótimo! Personagens criados. Agora podemos ajustar o que quiser — regras do mundo, subtramas, tom, segredos... O que mais você quer definir?',
    refine_ph: 'Ajuste personagens, regras do mundo, tom, subtramas... (Enter para enviar)',
    refine_hint: 'Quando a bíblia estiver completa, avance para configurar os livros.',
    refine_next: 'Bíblia aprovada — Configurar livros →',
    refine_back: '← Personagens',
    review_title: 'Configuração da Série',
    review_info: 'Revise e ajuste os detalhes antes de gerar o roteiro.',
    f_title: 'Título', f_subtitle: 'Subtítulo', f_author: 'Autor', f_genre: 'Gênero',
    f_tone: 'Tom', f_pov: 'Ponto de Vista', f_chapters: 'Capítulos por livro (máx. 10)',
    f_setting: 'Cenário', f_synopsis: 'Sinopse', f_style: 'Estilo de Escrita (opcional)',
    f_style_ph: 'Ex: "Estilo de Clarice Lispector, introspectivo e poético"',
    f_num_books: 'Livros na Série',
    f_num_books_hint: 'Cada livro se conectará ao anterior. O sistema garante que nenhum contradiga o outro.',
    plan_label: 'Plano necessário:',
    plan_free: 'Gratuito (1 livro)',
    plan_writer: 'Escritor (até 5 livros)',
    plan_pro: 'Profissional (ilimitado)',
    review_gen: 'Gerar Roteiro →',
    review_back: '← Voltar',
    outline_title: (n, t) => t > 1 ? `Roteiro — Livro ${n} de ${t}` : 'Roteiro dos Capítulos',
    outline_info: 'Revise o roteiro. Edite se quiser. Quando estiver satisfeito, comece a escrever.',
    outline_edit: '✏️ Editar', outline_save: '✓ Salvar',
    outline_back: '← Voltar', outline_regen: '↻ Regenerar', outline_write: '✍️ Escrever Livro',
    writing_title: (n, t) => t > 1 ? `✍️ Escrevendo Livro ${n} de ${t}...` : '✍️ Escrevendo o Livro...',
    done_title: (n, t) => t > 1 ? `🎉 Livro ${n} de ${t} Concluído!` : '🎉 Livro Concluído!',
    series_done: '🏆 Série Completa!',
    done_stop: '⏹ Parar',
    done_new: '+ Novo Projeto',
    done_next: (n, t) => `Escrever Livro ${n + 1} de ${t} →`,
    done_pdf: '📄 Exportar PDF', done_epub: '📱 Exportar EPUB',
    chaps_title: 'Capítulos',
    ch_pending: '⏳ Aguardando', ch_writing: '✍️ Escrevendo...', ch_done: '✅ Concluído', ch_error: '❌ Erro',
    of_chapters: (d, t) => `${d} de ${t} capítulos`,
    prev_books_ctx: (n) => `CONTEXTO DOS LIVROS ANTERIORES (CÂNONE IMUTÁVEL — nunca contradiga):`,
    book_label: (n) => `Livro ${n}`,
    author_placeholder: 'Seu nome',
  },

  en: {
    tagline: 'From thought to book — no hallucinations',
    ph0: '1. Bible', ph1: '2. Outline', ph2: '3. Writing',
    biblia_sub: 'Share your idea — we\'ll build the book bible together',
    biblia_label: 'Your Idea',
    biblia_ph: 'Write freely — a sentence, a paragraph, full worldbuilding.\n\nEx: I want to write a fantasy about a young blacksmith who discovers he can forge weapons from memories. The antagonist is an immortal king who collects stolen memories...',
    biblia_hint: 'Ctrl+Enter to submit',
    biblia_btn: 'Let\'s create my book →',
    load_building: 'Building the book bible...',
    load_chars: 'Creating characters...',
    load_outline: 'Generating outline...',
    load_writing: 'Writing chapter...',
    load_summary: 'Generating canonical summary...',
    chars_title: 'Characters',
    chars_regen: '↻ Regenerate all',
    chars_adjust: '✏️ Adjust this character',
    chars_what: 'What do you want to change?',
    chars_confirm: '✓ Adjust',
    chars_cancel: 'Cancel',
    chars_next: 'Refine the world →',
    chars_hint: 'Happy with the characters? Proceed to refine the world.',
    refine_title: 'Refining the World Bible',
    refine_intro: 'Characters created! Now let\'s refine anything you want — world rules, subplots, tone, secrets... What else do you want to define?',
    refine_ph: 'Adjust characters, world rules, tone, subplots... (Enter to send)',
    refine_hint: 'When the bible is complete, proceed to configure the books.',
    refine_next: 'Bible approved — Configure books →',
    refine_back: '← Characters',
    review_title: 'Series Configuration',
    review_info: 'Review and adjust details before generating the outline.',
    f_title: 'Title', f_subtitle: 'Subtitle', f_author: 'Author', f_genre: 'Genre',
    f_tone: 'Tone', f_pov: 'Point of View', f_chapters: 'Chapters per book (max 10)',
    f_setting: 'Setting', f_synopsis: 'Synopsis', f_style: 'Writing Style (optional)',
    f_style_ph: 'Ex: "Tolkien-inspired, rich and descriptive"',
    f_num_books: 'Books in Series',
    f_num_books_hint: 'Each book connects to the previous. The system ensures no book contradicts another.',
    plan_label: 'Required plan:',
    plan_free: 'Free (1 book)',
    plan_writer: 'Writer (up to 5 books)',
    plan_pro: 'Professional (unlimited)',
    review_gen: 'Generate Outline →',
    review_back: '← Back',
    outline_title: (n, t) => t > 1 ? `Outline — Book ${n} of ${t}` : 'Chapter Outline',
    outline_info: 'Review the outline. Edit if you want. When satisfied, start writing.',
    outline_edit: '✏️ Edit', outline_save: '✓ Save',
    outline_back: '← Back', outline_regen: '↻ Regenerate', outline_write: '✍️ Write Book',
    writing_title: (n, t) => t > 1 ? `✍️ Writing Book ${n} of ${t}...` : '✍️ Writing Book...',
    done_title: (n, t) => t > 1 ? `🎉 Book ${n} of ${t} Complete!` : '🎉 Book Complete!',
    series_done: '🏆 Series Complete!',
    done_stop: '⏹ Stop',
    done_new: '+ New Project',
    done_next: (n, t) => `Write Book ${n + 1} of ${t} →`,
    done_pdf: '📄 Export PDF', done_epub: '📱 Export EPUB',
    chaps_title: 'Chapters',
    ch_pending: '⏳ Pending', ch_writing: '✍️ Writing...', ch_done: '✅ Done', ch_error: '❌ Error',
    of_chapters: (d, t) => `${d} of ${t} chapters`,
    prev_books_ctx: (n) => `PREVIOUS BOOKS CONTEXT (IMMUTABLE CANON — never contradict):`,
    book_label: (n) => `Book ${n}`,
    author_placeholder: 'Your name',
  },

  es: {
    tagline: 'Del pensamiento al libro — sin alucinaciones',
    ph0: '1. Biblia', ph1: '2. Guión', ph2: '3. Escritura',
    biblia_sub: 'Cuéntanos tu idea — construiremos la biblia del libro juntos',
    biblia_label: 'Tu Idea',
    biblia_ph: 'Escribe libremente — una frase, un párrafo, worldbuilding completo...',
    biblia_hint: 'Ctrl+Enter para enviar',
    biblia_btn: 'Vamos a crear mi libro →',
    load_building: 'Construyendo la biblia del libro...',
    load_chars: 'Creando personajes...',
    load_outline: 'Generando guión...',
    load_writing: 'Escribiendo capítulo...',
    load_summary: 'Generando resumen canónico...',
    chars_title: 'Personajes',
    chars_regen: '↻ Regenerar todos',
    chars_adjust: '✏️ Ajustar este personaje',
    chars_what: '¿Qué quieres cambiar?',
    chars_confirm: '✓ Ajustar',
    chars_cancel: 'Cancelar',
    chars_next: 'Refinar el mundo →',
    chars_hint: '¿Satisfecho con los personajes? Procede a refinar el mundo.',
    refine_title: 'Refinando la Biblia del Mundo',
    refine_intro: '¡Personajes creados! Ahora podemos ajustar lo que quieras — reglas del mundo, subtramas, tono...',
    refine_ph: 'Ajusta personajes, reglas del mundo, tono... (Enter para enviar)',
    refine_hint: 'Cuando la biblia esté completa, procede a configurar los libros.',
    refine_next: 'Biblia aprobada — Configurar libros →',
    refine_back: '← Personajes',
    review_title: 'Configuración de la Serie',
    review_info: 'Revisa y ajusta los detalles antes de generar el guión.',
    f_title: 'Título', f_subtitle: 'Subtítulo', f_author: 'Autor', f_genre: 'Género',
    f_tone: 'Tono', f_pov: 'Punto de Vista', f_chapters: 'Capítulos por libro (máx. 10)',
    f_setting: 'Escenario', f_synopsis: 'Sinopsis', f_style: 'Estilo de Escritura (opcional)',
    f_style_ph: 'Ej: "Estilo de García Márquez, mágico y descriptivo"',
    f_num_books: 'Libros en la Serie',
    f_num_books_hint: 'Cada libro se conectará al anterior sin perder el hilo narrativo.',
    plan_label: 'Plan requerido:',
    plan_free: 'Gratuito (1 libro)',
    plan_writer: 'Escritor (hasta 5 libros)',
    plan_pro: 'Profesional (ilimitado)',
    review_gen: 'Generar Guión →',
    review_back: '← Volver',
    outline_title: (n, t) => t > 1 ? `Guión — Libro ${n} de ${t}` : 'Guión de Capítulos',
    outline_info: 'Revisa el guión. Edita si quieres. Cuando estés satisfecho, empieza a escribir.',
    outline_edit: '✏️ Editar', outline_save: '✓ Guardar',
    outline_back: '← Volver', outline_regen: '↻ Regenerar', outline_write: '✍️ Escribir Libro',
    writing_title: (n, t) => t > 1 ? `✍️ Escribiendo Libro ${n} de ${t}...` : '✍️ Escribiendo el Libro...',
    done_title: (n, t) => t > 1 ? `🎉 Libro ${n} de ${t} Completado!` : '🎉 Libro Completado!',
    series_done: '🏆 Serie Completa!',
    done_stop: '⏹ Parar',
    done_new: '+ Nuevo Proyecto',
    done_next: (n, t) => `Escribir Libro ${n + 1} de ${t} →`,
    done_pdf: '📄 Exportar PDF', done_epub: '📱 Exportar EPUB',
    chaps_title: 'Capítulos',
    ch_pending: '⏳ Esperando', ch_writing: '✍️ Escribiendo...', ch_done: '✅ Completado', ch_error: '❌ Error',
    of_chapters: (d, t) => `${d} de ${t} capítulos`,
    prev_books_ctx: () => `CONTEXTO DE LIBROS ANTERIORES (CANON INMUTABLE — nunca contradiga):`,
    book_label: (n) => `Libro ${n}`,
    author_placeholder: 'Tu nombre',
  },

  fr: {
    tagline: 'De la pensée au livre — sans hallucinations',
    ph0: '1. Bible', ph1: '2. Scénario', ph2: '3. Écriture',
    biblia_sub: 'Partagez votre idée — nous construirons la bible du livre ensemble',
    biblia_label: 'Votre Idée',
    biblia_ph: 'Écrivez librement — une phrase, un paragraphe, worldbuilding complet...',
    biblia_hint: 'Ctrl+Entrée pour envoyer',
    biblia_btn: 'Créons mon livre →',
    load_building: 'Construction de la bible du livre...',
    load_chars: 'Création des personnages...',
    load_outline: 'Génération du scénario...',
    load_writing: 'Écriture du chapitre...',
    load_summary: 'Génération du résumé canonique...',
    chars_title: 'Personnages',
    chars_regen: '↻ Régénérer tous',
    chars_adjust: '✏️ Ajuster ce personnage',
    chars_what: 'Que voulez-vous changer?',
    chars_confirm: '✓ Ajuster',
    chars_cancel: 'Annuler',
    chars_next: 'Affiner le monde →',
    chars_hint: 'Satisfait des personnages? Procédez à affiner le monde.',
    refine_title: 'Affinage de la Bible du Monde',
    refine_intro: 'Personnages créés! Maintenant affinons ce que vous voulez — règles du monde, intrigues, ton...',
    refine_ph: 'Ajustez les personnages, les règles du monde, le ton... (Entrée pour envoyer)',
    refine_hint: 'Quand la bible est complète, configurez les livres.',
    refine_next: 'Bible approuvée — Configurer les livres →',
    refine_back: '← Personnages',
    review_title: 'Configuration de la Série',
    review_info: 'Révisez et ajustez les détails avant de générer le scénario.',
    f_title: 'Titre', f_subtitle: 'Sous-titre', f_author: 'Auteur', f_genre: 'Genre',
    f_tone: 'Ton', f_pov: 'Point de Vue', f_chapters: 'Chapitres par livre (max 10)',
    f_setting: 'Cadre', f_synopsis: 'Synopsis', f_style: "Style d'Écriture (optionnel)",
    f_style_ph: 'Ex: "Style Proustien, introspectif et poétique"',
    f_num_books: 'Livres dans la Série',
    f_num_books_hint: 'Chaque livre se connectera au précédent sans perdre le fil narratif.',
    plan_label: 'Plan requis:',
    plan_free: 'Gratuit (1 livre)',
    plan_writer: 'Écrivain (jusqu\'à 5 livres)',
    plan_pro: 'Professionnel (illimité)',
    review_gen: 'Générer Scénario →',
    review_back: '← Retour',
    outline_title: (n, t) => t > 1 ? `Scénario — Livre ${n} sur ${t}` : 'Scénario des Chapitres',
    outline_info: 'Révisez le scénario. Modifiez si vous voulez. Quand vous êtes satisfait, écrivez.',
    outline_edit: '✏️ Modifier', outline_save: '✓ Sauvegarder',
    outline_back: '← Retour', outline_regen: '↻ Régénérer', outline_write: '✍️ Écrire le Livre',
    writing_title: (n, t) => t > 1 ? `✍️ Écriture Livre ${n} sur ${t}...` : '✍️ Écriture du Livre...',
    done_title: (n, t) => t > 1 ? `🎉 Livre ${n} sur ${t} Terminé!` : '🎉 Livre Terminé!',
    series_done: '🏆 Série Terminée!',
    done_stop: '⏹ Arrêter',
    done_new: '+ Nouveau Projet',
    done_next: (n, t) => `Écrire Livre ${n + 1} sur ${t} →`,
    done_pdf: '📄 Exporter PDF', done_epub: '📱 Exporter EPUB',
    chaps_title: 'Chapitres',
    ch_pending: '⏳ En attente', ch_writing: '✍️ En écriture...', ch_done: '✅ Terminé', ch_error: '❌ Erreur',
    of_chapters: (d, t) => `${d} sur ${t} chapitres`,
    prev_books_ctx: () => `CONTEXTE DES LIVRES PRÉCÉDENTS (CANON IMMUABLE — ne jamais contredire):`,
    book_label: (n) => `Livre ${n}`,
    author_placeholder: 'Votre nom',
  },
};

export function getTranslations(lang) {
  return TRANSLATIONS[lang] || TRANSLATIONS['en'];
}
